import { useGetListWalletProvider } from "../../api/wallet";

export const useWalletManagementProvider = (
  companyId: number,
  params: { start: number; end: number },
  name?: string,
  currencyId?: number
) => {
  const {
    data = {
      data: {
        data: { total: 0, pageSize: 10, page: 1, totalPages: 1, items: [] },
      },
    },
    isLoading,
    refetch,
  } = useGetListWalletProvider({
    companyId,
    ...params,
    name,
    currencyId,
  });
  return { dataListWalletProvider: data.data.data, isLoading, refetch };
};
